import type { Cti } from "@amzn/aquila-service-type-script-client";

export const IHUB_FEATURE_REQUEST_CTI: Cti = {
    category: "Advertising",
    type: "Insights Hub",
    item: "Feature Request",
    resolverGroup: "ads-helios-team",
};
